import styled from 'styled-components';
import Divider from 'components/Divider';
import { getThemeColor } from 'utils/styled';
import { LIST_PADDING_PX } from '../constants';
import { LoaderRowStyleProps } from './types';

export const Root = styled.div`
  outline: none;

  &[aria-selected='true'],
  &[data-hovered='true'] {
    background-color: ${getThemeColor('l3')};
  }
`;

export const GridCell = styled.div`
  padding: ${LIST_PADDING_PX}px;
`;

export const RowDivider = styled(Divider)`
  background-color: ${getThemeColor('l4')};
  width: unset;
  margin: 0 ${LIST_PADDING_PX}px;
`;

export const LoaderRoot = styled(Root)<LoaderRowStyleProps>`
  cursor: auto;

  ${({ $variant }) => $variant === 'grid' && 'grid-column: 1 / -1;'}
`;
